import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { sortFindingAids } from "../../actions/sortFindingAids";

function ResultsSort(props) {
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");
  const [orderButton, setOrderButton] = useState("");
  const [reset, setReset] = useState(false);
  const { findingAids, sortFindingAids } = props;
  const query = window.location.pathname;

  // Helper: ensure accessible name includes visible label text
  const buildAriaLabel = (visible, meaning) => `${visible} (${meaning})`;

  useEffect(() => {
    props.loading(true);
    props.sortInfo(sort);
    props.loading(false);
  }, [sort, findingAids]);

  useEffect(() => {
    sortOrderButtons();
  }, [order]);

  useEffect(() => {
    sortOrderButtons();
  }, [sort]);

  useEffect(() => {
    props.loading(true);
    sortFindingAids(sort, order);
    props.loading(false);
  }, [sort, order]);

  const handleOrderClick = () => {
    if (order === "up") {
      setOrder("down");
    } else if (order === "down") {
      setOrder("up");
    }
  };

  const sortOrderButtons = () => {
    if (sort === "creators" || sort === "title" || sort === "repository") {
      if (order === "up") {
        const visible = "A ⇅ Z";
        return setOrderButton(
          <button
            className="btn btn-light ml-3 "
            aria-pressed="true"
            aria-label={buildAriaLabel(visible, "sort A to Z")}
            onClick={(e) => handleOrderClick(e)}
          >
            A &#x021C5; Z
          </button>
        );
      } else if (order === "down") {
        const visible = "Z ⇅ A";
        return setOrderButton(
          <button
            className="btn btn-light ml-3 "
            aria-pressed="true"
            aria-label={buildAriaLabel(visible, "sort Z to A")}
            onClick={(e) => handleOrderClick(e)}
          >
            Z &#x021C5; A
          </button>
        );
      }
    } else if (sort === "start_dates" || sort === "end_dates") {
      if (order === "up") {
        const visible = "0 ⇅ 9";
        return setOrderButton(
          <button
            className="btn btn-light ml-3 "
            aria-pressed="true"
            aria-label={buildAriaLabel(visible, "sort oldest to newest")}
            onClick={(e) => handleOrderClick(e)}
          >
            0 &#x021C5; 9
          </button>
        );
      } else if (order === "down") {
        const visible = "9 ⇅ 0";
        return setOrderButton(
          <button
            className="btn btn-light ml-3 "
            aria-pressed="true"
            aria-label={buildAriaLabel(visible, "sort newest to oldest")}
            onClick={(e) => handleOrderClick(e)}
          >
            9 &#x021C5; 0
          </button>
        );
      }
    } else {
      setOrder("");
      setSort("");
      setReset(true);
      setOrderButton(() => {
        const visible = "A ⇅ Z";
        return (
          <button
            className="btn btn-outline-secondary ml-3 "
            aria-pressed="true"
            aria-label={buildAriaLabel(visible, "sort A to Z")}
            disabled
          >
            A &#x021C5; Z
          </button>
        );
      });
      setReset(false);
    }
  };

  const options = [
    { value: "default", select: "Category" },
    { value: "creators", select: "Creator" },
    { value: "title", select: "Title" },
    { value: "repository", select: "Repository" },
    { value: "start_dates", select: "Start Dates" },
    { value: "end_dates", select: "End Dates" },
  ];

  const handleSelect = (value) => {
    if (reset) {
      setOrder("");
      setSort(value);
    } else {
      setOrder("up");
      setSort(value);
    }
  };

  useEffect(() => {
    props.loading(true);
    setReset(true);
    setSort("");
    setOrder("");
    setReset(false);
    props.loading(false);
  }, [query]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="row mx-auto d-flex">
          <div className="col-12 mx-auto d-sm-flex justify-content-center align-items-center">
            <label
              htmlFor="sort_by"
              className="d-flex align-items-center justify-content-center text-center mb-0"
            >
              Sort By
            </label>
            <div className="m-3 align-items-center justify-content-center text-center">
              <select
                name="sort_by"
                className="custom-select page-sort__select"
                id="sort_by"
                defaultValue="default"
                value={reset ? "default" : sort}
                onChange={(e) => {
                  setReset(false);
                  handleSelect(e.target.value);
                }}
              >
                {options.map((entry, i) => {
                  return (
                    <option key={i} value={entry.value}>
                      {entry.select}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="d-flex align-items-center justify-content-center text-lg-start">
              {orderButton}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  findingAids: state.findingAids.findingAids,
});

export default connect(mapStateToProps, { sortFindingAids })(ResultsSort);